import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import { usePreloadedQuery} from 'react-relay'

import DialogTitle from '../../../../components/DialogTitle'
import Panel from '../../../../components/Panel/Panel'
import {ElementWidth} from '../../../../types/constEnums'
import OrgAuthenticationMetadata from './OrgAuthenticationMetadata'
import OrgAuthenticationSSOFrame from './OrgAuthenticationSSOFrame'
import OrgAuthenticationSignOnUrl from './OrgAuthenticationSignOnUrl'

const StyledPanel = styled(Panel)({
  maxWidth: ElementWidth.PANEL_WIDTH
})




const OrgAuthentication = (props) => {
  const {queryRef} = props
  const data = usePreloadedQuery(
    graphql`
      query OrgAuthenticationQuery($orgId: ID!) {
        viewer {
          organization(orgId: $orgId) {
            saml {
              ...OrgAuthenticationSSOFrame_saml
              ...OrgAuthenticationSignOnUrl_saml
              ...OrgAuthenticationMetadata_saml
              id
            }
          }
        }
      }
    `,
    queryRef
  )
  const {viewer} = data
  const {organization} = viewer
  const saml = _nullishCoalesce(_optionalChain([organization, 'optionalAccess', _ => _.saml]), () => ( null))
  const disabled = !saml
  return (
    _jsxs(StyledPanel, { children: [
      _jsx(DialogTitle, { className: "px-6 pt-5 pb-6"  , children: "SAML Single Sign-On"  })
      , _jsx(OrgAuthenticationSSOFrame, { samlRef: saml,} )
      , _jsxs('div', { className: disabled ? 'pointer-events-none opacity-40 select-none' : '', children: [
        _jsx(OrgAuthenticationSignOnUrl, { samlRef: saml,} )
        , _jsx(OrgAuthenticationMetadata, { samlRef: saml,} )
      ]})
    ]})
  )
}

export default OrgAuthentication
